module.exports = __webpack_public_path__ + "media/components/AnimatePath/svg/vostel-logo-7875a031332d3b385ecbe12232c118eacb946ad80a71c0373a89e51804ba7d63.svg";